var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import QRCodeGenerator from './QRCodeGenerator';
/**
 * Модальное окно для отображения QR-кода текущего URL страницы
 * Позволяет пользователям быстро получить ссылку на страницу через QR-код
 */
const QRCodeModal = ({ isOpen, onClose, url }) => {
    const { t } = useTranslation();
    const currentUrl = useMemo(() => {
        if (url) {
            return url;
        }
        return window.location.href;
    }, [url]);
    const handleCopyUrl = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(currentUrl);
        }
        catch (err) {
            console.error('Ошибка при копировании URL:', err);
        }
    });
    return (_jsx(Modal, { isOpen: isOpen, onRequestClose: onClose, contentLabel: "QR-\u043A\u043E\u0434 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B", style: {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
            },
            content: {
                position: 'relative',
                background: 'white',
                borderRadius: '12px',
                padding: '24px',
                maxWidth: '400px',
                width: '90%',
                border: 'none',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                outline: 'none',
            },
        }, children: _jsxs("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px',
            }, children: [_jsx("h3", { style: {
                        margin: '0',
                        fontSize: '18px',
                        fontWeight: '600',
                        color: '#111827',
                    }, children: t('board.qrCode.title', 'QR-код страницы') }), _jsx("div", { style: {
                        padding: '16px',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }, children: _jsx(QRCodeGenerator, { text: currentUrl, size: 256, level: "M" }) }), _jsxs("div", { style: {
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }, children: [_jsx("div", { style: {
                                padding: '8px 12px',
                                backgroundColor: '#f3f4f6',
                                borderRadius: '6px',
                                fontSize: '12px',
                                color: '#6b7280',
                                wordBreak: 'break-all',
                                maxHeight: '60px',
                                overflow: 'auto',
                            }, children: currentUrl }), _jsx("button", { onClick: handleCopyUrl, style: {
                                padding: '10px 16px',
                                borderRadius: '8px',
                                border: '1px solid #d1d5db',
                                background: 'white',
                                color: '#374151',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                transition: 'all 0.2s ease',
                            }, onMouseEnter: (e) => {
                                e.currentTarget.style.backgroundColor = '#f9fafb';
                                e.currentTarget.style.borderColor = '#9ca3af';
                            }, onMouseLeave: (e) => {
                                e.currentTarget.style.backgroundColor = 'white';
                                e.currentTarget.style.borderColor = '#d1d5db';
                            }, children: t('board.qrCode.copyUrl', 'Копировать URL') })] }), _jsx("button", { onClick: onClose, style: {
                        padding: '10px 16px',
                        borderRadius: '8px',
                        border: '1px solid #d1d5db',
                        background: 'white',
                        color: '#374151',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'all 0.2s ease',
                        width: '100%',
                    }, onMouseEnter: (e) => {
                        e.currentTarget.style.backgroundColor = '#f9fafb';
                        e.currentTarget.style.borderColor = '#9ca3af';
                    }, onMouseLeave: (e) => {
                        e.currentTarget.style.backgroundColor = 'white';
                        e.currentTarget.style.borderColor = '#d1d5db';
                    }, children: t('common.close', 'Закрыть') })] }) }));
};
export default QRCodeModal;
